import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent, cloneElement } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import QuestionIcon from '../icons/forms/QuestionIcon';
import { FixedOverlay } from '../Overlay';
import { withStyles } from '../theme';
import { ios, android } from '../utils/browser';
import HintContent from './HintContent';
var isMobileBehavior = ios || android;
var styles = {
  icon: {
    display: 'inline-block'
  }
};

var Hint = /*#__PURE__*/function (_PureComponent) {
  _inherits(Hint, _PureComponent);

  var _super = _createSuper(Hint);

  function Hint() {
    var _this;

    _classCallCheck(this, Hint);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      isOpened: _this.props.isOpened || false
    };
    _this.containerStyle = isMobileBehavior ? {
      left: 0,
      right: 0
    } : null;

    _this.show = function () {
      if (_this.state.isOpened) clearTimeout(_this.hideTimeout);else _this.setState({
        isOpened: true
      });
    };

    _this.hide = function () {
      if (!_this.state.isOpened) return;
      clearTimeout(_this.hideTimeout);
      _this.hideTimeout = setTimeout(function () {
        _this.setState({
          isOpened: false
        });
      }, 60);
    };

    return _this;
  }

  _createClass(Hint, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var isOpened = this.props.isOpened;
      if (isOpened !== undefined && isOpened !== prevProps.isOpened) if (isOpened) this.show();else this.hide();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          className = _this$props.className,
          style = _this$props.style,
          contentClassName = _this$props.contentClassName,
          contentStyle = _this$props.contentStyle,
          icon = _this$props.icon,
          renderAnchor = _this$props.renderAnchor,
          children = _this$props.children,
          positionX = _this$props.positionX,
          theme = _this$props.theme,
          classes = _this$props.classes,
          autoPositionY = _this$props.autoPositionY,
          closeOnScroll = _this$props.closeOnScroll;
      var isOpened = this.state.isOpened;
      var pointX = positionX === 'left' ? 'right' : 'left';
      return React.createElement(FixedOverlay, {
        isOpened: isOpened,
        anchor: function anchor(ref) {
          var iconElement = icon(ref);
          return cloneElement(renderAnchor(cloneElement(iconElement, {
            color: iconElement.props.color || (isOpened ? theme.hint.icon.colors.active : theme.hint.icon.colors.default),
            style: style,
            className: classnames(classes.icon, className)
          })), {
            onMouseEnter: _this2.show,
            onTouchStart: _this2.show,
            onMouseLeave: _this2.hide
          });
        },
        content: React.createElement(HintContent, {
          className: contentClassName,
          style: contentStyle,
          icon: icon(),
          onMouseEnter: this.show,
          onMouseLeave: this.hide
        }, children),
        autoPositionX: !isMobileBehavior,
        autoPositionY: autoPositionY,
        anchorPointX: isMobileBehavior ? 'center' : pointX,
        contentPointX: isMobileBehavior ? 'center' : pointX,
        anchorPointY: isMobileBehavior ? 'bottom' : 'top',
        contentPointY: "top",
        cachePositionOptions: false,
        closeOnScroll: closeOnScroll,
        onContentClose: this.hide,
        containerNodeStyle: this.containerStyle
      });
    }
  }]);

  return Hint;
}(PureComponent);

Hint.defaultProps = {
  positionX: 'right',
  autoPositionY: true,
  closeOnScroll: true,
  icon: function icon(ref) {
    return React.createElement(QuestionIcon, {
      nodeRef: ref,
      size: 15
    });
  },
  renderAnchor: function renderAnchor(icon) {
    return icon;
  }
};
Hint.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Класс якоря
   */
  className: PropTypes.string,

  /**
   * Стили якоря (Иконки)
   */
  style: PropTypes.object,

  /**
   * Функция, возвращающая иконку, по-умолчанию `<QuestionIcon />`. Принимает коллбек для передачи ссылки на ноду в качестве аргумента
   */
  icon: PropTypes.func.isRequired,

  /**
   * Класс контента подсказки
   */
  contentClassName: PropTypes.string,

  /**
   * Стили контента посказки
   */
  contentStyle: PropTypes.object,

  /**
   * Контент для подсказки
   */
  children: PropTypes.node.isRequired,

  /**
   * Функция, возвращающая элемент якоря, по-умолчанию возвращает иконку. Принимает иконку.
   */
  renderAnchor: PropTypes.func,

  /**
   * Флаг показа подсказки. Если ничего не указано, подсказка будет показываться при hover
   */
  isOpened: PropTypes.bool,

  /**
   * Позиция тултипа по оси X: left - слева от якоря, right - справа
   */
  positionX: PropTypes.oneOf(['left', 'right']),

  /**
   * Автоматическое позиционирование по оси Y (если выходит за пределы экрана)
   */
  autoPositionY: PropTypes.bool,

  /**
   * Скрывать при скролле страницы
   */
  closeOnScroll: PropTypes.bool
} : {};
export default withStyles(styles, {
  name: 'Hint'
})(Hint);